import React from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';

// import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
// import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
// import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
// import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
// import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
// import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
// import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
// import Heading from '@ckeditor/ckeditor5-heading/src/heading';
// import Image from '@ckeditor/ckeditor5-image/src/image';
// import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
// import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
// import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
// import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
// import Link from '@ckeditor/ckeditor5-link/src/link';
// import List from '@ckeditor/ckeditor5-list/src/list';
// import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
// import Link from '@ckeditor/ckeditor5-link/src/link';
// import List from '@ckeditor/ckeditor5-list/src/list';
// import TodoList from '@ckeditor/ckeditor5-list/src/todolist';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import FontSize from '@ckeditor/ckeditor5-font/src/fontsize';
import FontFamily from '@ckeditor/ckeditor5-font/src/fontfamily';
import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor';
import FontBackgroundColor from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor';
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';
import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat';
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript';
import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript';

import DEFINE, { CONFIG_LOCAL_STORAGE, UPLOAD_DIRECTORY } from '../../../../../constants/Define';
import i18n from '../../../../../constants/initLng';

import RichTextUploadAdapter from './plugins/RichTextUploadAdapter';
import ImageLink from './plugins/RichTextImageLink';
import CustomButton from './plugins/CustomButton';

import Config from '../../../../../constants/Config';
import * as Icons from './icons';
import { LocalStorage } from '../../../../../utils';
import Urls from '../../../../../api/Urls';
import { Icon } from 'antd';
import { omit, merge, unionBy } from 'lodash';

import './styles.less';


const path = require('path');

const RichTextEditor = React.forwardRef((props, ref) => {
    const config = props.config || {};
    const onInit = (editor) => {
        const initialData = props.data === null || props.data === undefined ? '' : props.data;
        if (editor.getData() !== initialData) {
            editor.setData(initialData);
        }
        const uploadDirectory = props.config && props.config.uploadDirectory;
        const token = LocalStorage.get(CONFIG_LOCAL_STORAGE.ACCESS_TOKEN);
        const uploadHeaders = {
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`,
        };
        const uploadConfig = {
            url: `${Config.API_CMS}${Urls.UPLOAD_STORAGE}`,
            urlParser: (data) => `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${data.fileUrl}`,
            headers: uploadHeaders,
            directory: uploadDirectory || UPLOAD_DIRECTORY.GENERAL,
        };
        editor.plugins.get('FileRepository').createUploadAdapter = loader => new RichTextUploadAdapter(loader, uploadConfig, props.t);

        if (props.onInit) {
            props.onInit(editor);
        }
    }
    const [isFullscreen, setFullscreen] = React.useState(false);
    const toggleFullScreen = (buttonView) => {
        if (buttonView && buttonView.icon === Icons.FullScreenExit) {
            setFullscreen(false);
            buttonView.set({ icon: Icons.FullScreen, label: i18n.t(`action.maximize`) });
        } else {
            setFullscreen(!isFullscreen);
            if (buttonView && buttonView.set) {
                buttonView.set({ icon: Icons.FullScreenExit, label: i18n.t(`action.minimize`) });
            }
        }
    };
    const newConfig = {
        ...config,
        resize_dir: 'vertical',
        customButton: [
            {
                name: "fullScreen",
                label: i18n.t(`action.maximize`),
                icon: Icons.FullScreen,
                withText: false,
                tooltip: true,
                syncDisabledState: true,
                onClick: toggleFullScreen,
            }
        ],
        fullPage: true,
        allowedContent: true,
    };

    const newProps = omit(props, 'config');
    const safeData = newProps.data === null || newProps.data === undefined ? '' : newProps.data;

    // The React adapter already synchronizes data. A passive effect can replay
    // stale HTML between typing and autoformat changes, re-entering the model.

    return (
        <div className={`hms-rich-text-editor-wrapper ${isFullscreen ? 'fullscreen' : ''}`}>
            <CKEditor {...newProps}
                data={safeData}
                ref={ref} config={newConfig}
                onInit={onInit}
                className={`hms-rich-text-editor ${props.className}`} />
        </div>
    )
})

export default RichTextEditor;
export const ClassicEditor = require('@ckeditor/ckeditor5-build-classic');
ClassicEditor.defaultConfig = {
    ...ClassicEditor.defaultConfig,
    toolbar: {
        ...ClassicEditor.defaultConfig.toolbar,
        items: [
            'heading', '|',
            'removeFormat', '|',
            'fontsize', 'fontfamily', 'fontColor', 'fontBackgroundColor', '|',
            'bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', 'highlight', '|',
            'alignment', '|',
            'numberedList', 'bulletedList', '|',
            'indent', 'outdent', '|',
            'link', 'blockquote', 'imageUpload',
            'insertTable', 'mediaEmbed', '|',
            'undo', 'redo', '|',
            'fullScreen',
        ],
    },
    image: {
        resizeUnit: 'px',
        toolbar: [
            'imageStyle:alignLeft',
            'imageStyle:full',
            'imageStyle:alignRight',
            '|',
            'imageTextAlternative',
            '|',
            'unlinkImage',
        ],
        styles: [
            'full',
            'alignLeft',
            'alignRight'
        ]
    },
    link: {
        decorators: {
            addTargetToExternalLinks: {
                mode: 'manual',
                label: i18n.t(`action.openInNewTab`),
                attributes: {
                    target: '_blank',
                    rel: 'noopener noreferrer'
                }
            },
            toggleDownloadable: {
                mode: 'manual',
                label: i18n.t(`action.downloadable`),
                attributes: {
                    download: 'file'
                }
            }
        }
    },
};
ClassicEditor.builtinPlugins = unionBy(ClassicEditor.builtinPlugins.concat([
    ImageLink,
    CustomButton,
    Underline,
    Strikethrough,
    FontSize,
    FontFamily,
    FontColor,
    FontBackgroundColor,
    Highlight,
    Alignment,
    Indent, IndentBlock,
    Subscript, Superscript,
    RemoveFormat,
]), 'pluginName');
// const plugins = ClassicEditor.builtinPlugins.map(plugin => plugin.pluginName);
